var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showStatus)?_c('v-chip',{staticClass:"ma-2 white--text",attrs:{"label":"","small":"","color":"warning"}},[_vm._v(" Pendente admin ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }